import axios from '../../utils/axios2';

export default {

    namespaced: true,

    state: {
        permissions: null
    },
    
    mutations: {
        setPermissions(state, payload) {
            state.permissions = payload;
        }
    },

    actions: {
        fetchPermissions({commit, rootState}) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `permissions`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setPermissions", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        }
    }

}